import { Toaster } from "react-hot-toast";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";

import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import "./App.css";

import Login from "./AdminPannel/Login";
import ContactForm from "./ContactForm/contactform";
import WebRegForm from "./ContactForm/webRegForm";
import Landing from "./AdminPannel/Landing";
import MainHeader from "./Header/MainHeader";
import Feedback from "./FeedbackPannel/Feedback";
import Main from "./Main/Main";
import RobatMaster from "./AdminPannel/RobotMaster";
import Feedbacktemplatemaster from "./AdminPannel/Feedbacktemplatemaster";
import EventMaster from "./AdminPannel/EventMaster";

import authStore from "./services/authStore";

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();

  const [checkingAuth, setCheckingAuth] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      const params = new URLSearchParams(location.search);
      const urlToken = params.get("token");

      const storedToken = authStore.getToken();

      // CASE 1: login via URL token (?token=abc)
      if (urlToken) {
        authStore.setToken(urlToken);
        setIsAuthenticated(true);

        toast.success("Login successful", { id: "login" });

        navigate("/", { replace: true });
      }

      // CASE 2: already logged in (refresh / back)
      else if (storedToken) {
        setIsAuthenticated(true);
      }

      // CASE 3: no token at all → unauthorized
      else {
        setIsAuthenticated(false);
      }

      setCheckingAuth(false);
    };

    initAuth();
  }, [location.search, navigate]);

  if (checkingAuth) {
    return <div>Loading...</div>;
  }

  // ONLY when truly not authenticated
  if (!isAuthenticated) {
    return <div>Unauthorized</div>;
  }

  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/MainHeader" element={<MainHeader />} />
      <Route path="/Feedback" element={<Feedback />} />
      <Route path="/WebRegFrom" element={<WebRegForm />} />
      <Route path="/ContactForm" element={<ContactForm />} />
      <Route path="/login" element={<Login />} />
      <Route path="/landing" element={<Landing />} />
      <Route path="/robatmaster" element={<RobatMaster />} />
      <Route
        path="/feedbacktemplatemaster"
        element={<Feedbacktemplatemaster />}
      />
      <Route path="/EventMaster" element={<EventMaster />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            padding: "12px 16px",
            borderRadius: "10px",
            fontSize: "14px",
            background: "#ffffff",
            color: "#334155",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          },
          success: {
            iconTheme: {
              primary: "#0fbc8c",
              secondary: "#ffffff",
            },
            style: {
              borderLeft: "5px solid #0fbc8c",
            },
          },
          error: {
            iconTheme: {
              primary: "#ff4d4f",
              secondary: "#ffffff",
            },
            style: {
              borderLeft: "5px solid #ff4d4f",
            },
          },
          loading: {
            style: {
              borderLeft: "5px solid #3b82f6",
            },
          },
        }}
      />

      <AppContent />
    </Router>
  );
}
